import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23d78166"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product__card-top container_car-count" }
const _hoisted_2 = { class: "fz-smaller product__card-model product__card-name" }
const _hoisted_3 = {
  key: 0,
  class: "icon_block"
}
const _hoisted_4 = { class: "title_block" }
const _hoisted_5 = { class: "counter_value" }
const _hoisted_6 = { style: {"margin-left":"5px"} }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "product__card-overlay" }
const _hoisted_9 = {
  key: 0,
  class: "swiper-container slider__gallery product__card-slider"
}
const _hoisted_10 = { class: "swiper-wrapper" }
const _hoisted_11 = ["data-src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-lazy-preloader" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "slider__gallery-arrows product__card-arrows"
}
const _hoisted_14 = ["href", "onClick"]
const _hoisted_15 = ["href", "onClick"]
const _hoisted_16 = { class: "product__card-bottom" }
const _hoisted_17 = {
  key: 0,
  class: "product__card-price"
}
const _hoisted_18 = {
  key: 0,
  class: "price__bottom"
}
const _hoisted_19 = {
  key: 0,
  class: "h4"
}
const _hoisted_20 = {
  key: 1,
  class: "h4"
}
const _hoisted_21 = { class: "price__bottom-text" }
const _hoisted_22 = {
  key: 1,
  class: "special-offer"
}
const _hoisted_23 = { class: "product__card-features" }
const _hoisted_24 = {
  key: 0,
  style: {"display":"flex","flex-wrap":"wrap"}
}
const _hoisted_25 = {
  class: "features__list-label tooltip__info",
  style: {"white-space":"nowrap"}
}
const _hoisted_26 = {
  key: 0,
  class: "features__list-text"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "KM", -1))
const _hoisted_28 = {
  key: 1,
  class: "features__list-text"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "KM", -1))
const _hoisted_30 = {
  class: "features__list-label features__list-text",
  style: {"white-space":"nowrap"}
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "product__card-stock" }
const _hoisted_34 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_format_currency = _resolveComponent("app-format-currency")!
  const _directive_tippy = _resolveDirective("tippy")!
  const _directive_app_gallery = _resolveDirective("app-gallery")!
  const _directive_app_auth_required = _resolveDirective("app-auth-required")!

  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "c-product_card" }, _ctx.$attrs, {
    class: { product__card: _ctx.source !== 'vehicles-details-swiper' },
    style: { 'margin-left': _ctx.source === 'vehicles-details-swiper' ? 0 : undefined }
  }), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("h5", {
          class: "h5 product__card-name",
          style: _normalizeStyle(_ctx.showIcon && _ctx.groupDto.vehicle_counter > 1 ? 'padding-right: 5.0666666667rem;' : '')
        }, _toDisplayString(_ctx.concatenateStrings(_ctx.groupDto.brands.map((brand) => brand.name))) + " " + _toDisplayString(_ctx.concatenateStrings(_ctx.groupDto.models)) + " " + _toDisplayString(_ctx.concatenateStrings(_ctx.groupDto.finishes)), 5),
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.vehicleInfoName), 1)
        ])), [
          [_directive_tippy, { content: _ctx.vehicleInfoName }]
        ])
      ]),
      (_ctx.showIcon && _ctx.groupDto.vehicle_counter > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.groupDto.vehicle_counter), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                width: "44",
                height: "17",
                src: `/img/${_ctx.brandLabel}/icon-cars.png`,
                alt: "#"
              }, null, 8, _hoisted_7)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["product__card-picture", { 'arrow-hover': _ctx.arrowHover }])
    }, [
      _createElementVNode("div", _hoisted_8, [
        (_ctx.groupDto.thumbnail_images?.length)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupDto.thumbnail_images, (image) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "swiper-slide dflex",
                    key: image.href_small
                  }, [
                    _createElementVNode("img", {
                      class: "swiper-lazy",
                      "data-src": image.href_small,
                      style: {
                                    objectFit: 'cover',
                                    'background-color': '#f4f8fd',
                                }
                    }, null, 8, _hoisted_11),
                    _hoisted_12
                  ]))
                }), 128))
              ]),
              (_ctx.groupDto.thumbnail_images.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", {
                      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.arrowHover = true)),
                      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.arrowHover = false)),
                      class: "product__card-arrow swiper-button-next product__card-slider-next"
                    }, null, 32),
                    _createElementVNode("div", {
                      onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.arrowHover = true)),
                      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.arrowHover = false)),
                      class: "product__card-arrow swiper-button-prev product__card-slider-prev"
                    }, null, 32)
                  ]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_app_gallery]
            ])
          : _createCommentVNode("", true),
        (_ctx.groupDto.vehicle_counter > 1)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: {
                        path: `/auth/vehicles`,
                        query: {
                            ..._ctx.getVehicleGroupingQueryParameters,
                            ..._ctx.filters,
                        },
                    },
              custom: ""
            }, {
              default: _withCtx(({ href, navigate }) => [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: href,
                  class: "button button--outline",
                  onClick: _withModifiers(
                            () =>
                                _ctx.routeToCarDetails(
                                    navigate,
                                    true /* TODO: vehicleDto.promotions === carLabel.specialDeal, */,
                                )
                        , ["prevent"])
                }, [
                  _createVNode(_component_i18n_t, { keypath: "carCard.viewVehicles" })
                ], 8, _hoisted_14)), [
                  [_directive_app_auth_required, {
                            role: 'dealer',
                            showLogin: !_ctx.isAuthenticated,
                            disable: true, // TODO: vehicleDto.promotions === carLabel.specialDeal
                        }]
                ])
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: {
                        path: `/auth/vehicle-details/${_ctx.groupDto.vehicle_ids[0]}`,
                        query: {
                            ..._ctx.getVehicleGroupingQueryParameters,
                            ..._ctx.filters,
                        },
                    },
              custom: ""
            }, {
              default: _withCtx(({ href, navigate }) => [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: href,
                  class: "button button--outline",
                  onClick: _withModifiers(
                            () =>
                                _ctx.routeToCarDetails(
                                    navigate,
                                    true /* TODO: vehicleDto.promotions === carLabel.specialDeal, */,
                                )
                        , ["prevent"])
                }, [
                  _createVNode(_component_i18n_t, { keypath: "carCard.viewDetails" })
                ], 8, _hoisted_15)), [
                  [_directive_app_auth_required, {
                            role: 'dealer',
                            showLogin: !_ctx.isAuthenticated,
                            disable: true, // TODO: vehicleDto.promotions === carLabel.specialDeal
                        }]
                ])
              ]),
              _: 1
            }, 8, ["to"]))
      ])
    ], 2),
    _createElementVNode("div", _hoisted_16, [
      (_ctx.isAuthenticated && _ctx.groupDto.price_min)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            (_ctx.groupDto.price_min && _ctx.groupDto.price_max)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.groupDto.price_min !== _ctx.groupDto.price_max)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                        _createVNode(_component_app_format_currency, {
                          value: _ctx.groupDto.price_min,
                          currency: _ctx.currency
                        }, null, 8, ["value", "currency"]),
                        _createTextVNode(" - "),
                        _createVNode(_component_app_format_currency, {
                          value: _ctx.groupDto.price_max,
                          currency: _ctx.currency
                        }, null, 8, ["value", "currency"])
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_20, [
                        _createVNode(_component_app_format_currency, {
                          value: _ctx.groupDto.price_min,
                          currency: _ctx.currency
                        }, null, 8, ["value", "currency"])
                      ])),
                  _createElementVNode("span", _hoisted_21, [
                    _createVNode(_component_i18n_t, { keypath: "carCard.excludeVAT" })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.groupDto.has_deal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_i18n_t, { keypath: "carCard.specialOffer" })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        (_ctx.groupDto.mileage_min)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
                (_ctx.groupDto.mileage_min !== _ctx.groupDto.mileage_max)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                      _createTextVNode(_toDisplayString(_ctx.groupDto.mileage_min) + " - " + _toDisplayString(_ctx.groupDto.mileage_max) + " ", 1),
                      _hoisted_27
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_28, [
                      _createTextVNode(_toDisplayString(_ctx.groupDto.mileage_min) + " ", 1),
                      _hoisted_29
                    ]))
              ])), [
                [_directive_tippy, {
                            content: _ctx.i18n.t('carCard.kmUsed'),
                            interactive: true,
                        }]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                (
                                _ctx.groupDto.firstregistration_date_max != null &&
                                _ctx.groupDto.firstregistration_date_min != null
                            )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.formatDate(_ctx.groupDto.firstregistration_date_min) !== _ctx.formatDate(_ctx.groupDto.firstregistration_date_max) ? 
                            `${_ctx.formatDate(_ctx.groupDto.firstregistration_date_min)} - ${_ctx.formatDate(_ctx.groupDto.firstregistration_date_max)}` : 
                            _ctx.formatDate(_ctx.groupDto.firstregistration_date_min)), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_32, [
                      _createElementVNode("b", null, [
                        _createVNode(_component_i18n_t, { keypath: "common.noReg" })
                      ])
                    ]))
              ])), [
                [_directive_tippy, {
                            content: _ctx.i18n.t('carDetails.date'),
                            interactive: true,
                        }]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("p", {
          class: "stock__label",
          innerHTML: _ctx.i18n.t('carCard.inStock', _ctx.groupDto.vehicle_counter)
        }, null, 8, _hoisted_34),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupDto.exterior_color_variants, (variant) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: variant.color.id,
            class: _normalizeClass(["stock__color purple tooltip__info", [`--${variant.color.name}`]]),
            style: _normalizeStyle({
                        backgroundColor: variant.color.hex,
                        color: variant.color.is_light ? 'black' : 'white',
                    })
          }, [
            _createTextVNode(_toDisplayString(variant.vehicle_counter), 1)
          ], 6)), [
            [_directive_tippy, {
                        content: variant.color.name,
                        interactive: true,
                    }]
          ])
        }), 128))
      ])
    ])
  ], 16))
}